import Cookies from 'js-cookie';

export const getRole = () => {
  let roleValue = Cookies.get('role');
  let roleArray = [];
  if(roleValue) {
    roleArray = JSON.parse(roleValue);
  }
  return roleArray;
}